<ul>
    <li *ngFor="let domain of filteredDomains">
        <ul>
            <li class="sub-domain" *ngFor="let subdomain of domain?.Subdomains">
                <ng-template
                    [ngTemplateOutlet]="itemTemplate"
                    [ngTemplateOutletContext]="{ 
                        $implicit: {
                            domain: domain?.Value, 
                            subdomain: subdomain 
                        } 
                    }">
                </ng-template>
            </li>
        </ul>
    </li>
</ul>
